import React from 'react';
import Layout from '../layouts/Layout';
import { Container, Title, Text, List, Paper, Stack, Code } from '@mantine/core';
import Footer from '../components/Footer';

const Privacy: React.FC = () => {
    return (
        <Layout>
            <Container size="lg">
                <Paper p="md" my="md">
                    <Stack my='xl' gap="xs">
                        <Title order={1}>Privacy Policy</Title>
                        <Title order={4}>Calensync</Title>
                        <Text size="sm">Service provided by Opali S.A.R.L.-S</Text>
                    </Stack>

                    <Stack>
                        <Title order={2}>For visitors on the website</Title>
                        <List px="md">
                            <List.Item>Personal data isn't gathered.</List.Item>
                            <List.Item>Cookies or other information aren't stored within browsers.</List.Item>
                            <List.Item>No information is ever passed to, forwarded, or sold to third parties.</List.Item>
                            <List.Item>No information is extracted for analysis of personal behaviour or trends.</List.Item>
                        </List>

                        <Title order={2}>For users of the app</Title>
                        <List px="md">
                            <List.Item>The email for the Google accounts you decide to connect is stored for necessary usage,
                            and is never shared with any third-party.</List.Item>
                            <List.Item>A first party cookie is used in order to keep track of your logged in session.</List.Item>
                            <List.Item>
                                A metadata copy of your calendar events is kept in the database. By metadata, we mean only the event_id (a completely anonymous string)
                                as well as the start and end date of the event. These are required for the application to work properly. These pieces of information 
                                are not shared in any shape or form with any third-party.
                            </List.Item>
                            <List.Item>
                                Your email will only be used for marketing purposes if you explicitely give use the right to (this can be done at the checkout).
                                We may contact you by email for non-marketing purposes, such as for updates to the to the policy or to the pricing.
                            </List.Item>
                            <List.Item>Payment is facilitated by Paddle; as part of the payment, you may
                                be required to submit an email which they process for billing. See their privacy policy for information.</List.Item>
                        </List>

                        <Text>We use four external providers.</Text>
                        <List px="md">
                            <List.Item>Amazon Web Services, Inc. for the infrastructure. It is fully hosted in Sweden / Stockholm, eu-north-1, and allthe data is kept and processed in this region only</List.Item>
                            <List.Item>Paddle.com Market Ltd for the payment processing</List.Item>
                            <List.Item>Github.com for website hosting</List.Item>
                            <List.Item>Google.com to be able to connect to your accounts and calendars, as described in this document.</List.Item>
                        </List>

                        <Text>The scope used for the Google API are:</Text>
                        <List px="md">
                            <List.Item><Code>openid, /auth/userinfo.email</Code>: used to log the user in and get the email</List.Item>
                            <List.Item><Code>/auth/calendar.calendarlist.readonly</Code>: be able to list the calendars owned by the user.</List.Item>
                            <List.Item>
                                <Code>/auth/calendar.events</Code>: be able to read, update, and delete events. <Text span fw={700}>Note:</Text> we 
                                will only ever delete events created by Calensync. We take special care in our software to 
                                make it impossible to delete any event not created by us.
                            </List.Item>
                        </List>

                        {/* Continue pattern for remaining sections */}
                    </Stack>
                </Paper>
            </Container>
        </Layout>
    );
};

export default Privacy;
